import { goBack } from 'connected-react-router';
import _ from 'lodash';
import { getRootURL } from '../browser-store';

// helper to tell us if we're on the client
export const isClient =
    typeof window !== 'undefined' && window.document && window.document.createElement;

// helper to tell us if we're on the server
export const isServer = !isClient;

export const redirectTo = (location) => {
    if (isClient) {
        window.location.assign(location);
    }
};

export const redirectToRoot = () => {
    redirectTo(getRootURL());
};

export const isInViewport = (el) => {
    const bounding = el.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

// TODO MSGW-1050 : Replace/Move into a RoutingHelper instance
export const popLocationToDispatch = () => {
    if (isClient) {
        return goBack();
    }
};
// TODO MSGW-1050 : Replace/Move into a RoutingHelper instance
export const getRouteAfterUpdatingFilterType = (
    location,
    destinationFolder,
    shouldKeepChannelSid = false
) => {
    let path = _.get(location, 'pathname', '');
    // If the previous path is '/', should keep the same, otherwise new path should be '/conversations/'
    // For example, when previously user is viewing a conversation:
    // the url is '/conversations/1', so we want it to be '/conversations/' when user select a new folder
    if (!shouldKeepChannelSid) {
        path = path === '/' ? '/' : '/conversations/';
    }
    const query = _.get(location, 'search', '');
    const queryParams = new URLSearchParams(query);
    queryParams.set('filter', destinationFolder);
    const newRoute = `${path}?${queryParams.toString()}`;

    return newRoute;
};

export const resetUrlToConversationListView = (location) => {
    const query = _.get(location, 'search', '');
    const queryParams = new URLSearchParams(query);
    return `/conversations/?${queryParams.toString()}`;
};

export const remValueToRuntimePxValue = (remValue) => {
    if (!remValue) {
        return 0;
    }

    let pxMultiplier = 16; // fallback

    if (document.documentElement && getComputedStyle) {
        const runtimePxMultiplier = parseFloat(getComputedStyle(document.documentElement).fontSize);

        if (runtimePxMultiplier && runtimePxMultiplier > 0) {
            pxMultiplier = runtimePxMultiplier;
        }
    }

    return remValue * pxMultiplier;
};

export default {
    redirectTo,
    redirectToRoot,
    isInViewport,
};
